class CTCartOfferController {
  constructor(configElement) {
    this.offer = window.CTCartOffer;
    if (!this.offer || !configElement) return;

    this.offer.configure(configElement.dataset);
    this.onOfferChange = this.render.bind(this);
    document.addEventListener('ct:cart-offer:change', this.onOfferChange);

    document.addEventListener('submit', (event) => {
      if (!event.target.matches('#cart-footer[data-ct-offer-checkout-form]')) return;
      if (!this.offer.snapshot().active) return;
      event.preventDefault();
      this.offer.claim();
    });

    const initialCart = {
      token: configElement.dataset.cartToken,
      total_price: Number(configElement.dataset.cartTotal || 0),
      currency: configElement.dataset.cartCurrency,
      item_count: Number(configElement.dataset.cartItemCount || 0),
    };

    this.render({ detail: this.offer.hydrate(initialCart) });
    this.subscribeToCartUpdates();
  }

  subscribeToCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event.cartData) return;
      this.offer.updateCart(event.cartData);
    });
  }

  render(event) {
    const snapshot = event.detail || this.offer.snapshot();

    document.querySelectorAll('[data-ct-cart-offer-notice]').forEach((element) => {
      element.hidden = !snapshot.active;
    });
    document.querySelectorAll('[data-ct-offer-default-label]').forEach((element) => {
      element.hidden = snapshot.active;
    });
    document.querySelectorAll('[data-ct-offer-active-label]').forEach((element) => {
      element.hidden = !snapshot.active;
    });
    document.querySelectorAll('[data-ct-offer-timer]').forEach((element) => {
      element.textContent = this.offer.formatTime(snapshot.remainingSeconds);
    });
    document.querySelectorAll('[data-ct-offer-percent]').forEach((element) => {
      element.textContent = snapshot.percent;
    });
    document.querySelectorAll('[data-ct-offer-button-price]').forEach((element) => {
      element.textContent = this.offer.formatMoney(snapshot.discountedPrice, snapshot.currency);
    });
  }
}

class CTCartPreviewModal {
  constructor(modal) {
    this.modal = modal;
    this.dialog = modal.querySelector('.ct-cart-preview-modal__dialog');
    this.image = modal.querySelector('[data-ct-cart-preview-image]');
    this.title = modal.querySelector('[data-ct-cart-preview-title]');
    this.lastTrigger = null;

    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-ct-cart-preview-open]');

      if (openButton) {
        event.preventDefault();
        this.open(openButton);
        return;
      }

      const closeButton = event.target.closest('[data-ct-cart-preview-close]');

      if (closeButton && this.modal.contains(closeButton)) {
        event.preventDefault();
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.modal.hidden) {
        this.close();
      }
    });
  }

  open(trigger) {
    const imageSource = trigger.dataset.previewSrc;
    const imageAlt = trigger.dataset.previewAlt || '';
    const productTitle = trigger.dataset.previewTitle || 'Product preview';

    if (!imageSource) return;

    this.lastTrigger = trigger;

    this.image.src = imageSource;
    this.image.alt = imageAlt;
    this.title.textContent = productTitle;

    this.modal.hidden = false;
    document.body.classList.add('ct-cart-preview-is-open');

    window.requestAnimationFrame(() => {
      this.dialog.focus();
    });
  }

  close() {
    this.modal.hidden = true;
    document.body.classList.remove('ct-cart-preview-is-open');

    this.image.src = '';
    this.image.alt = '';

    if (this.lastTrigger) {
      this.lastTrigger.focus();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const cartOfferConfig = document.querySelector('[data-ct-cart-offer-config]');
  if (cartOfferConfig) new CTCartOfferController(cartOfferConfig);

  const previewModal = document.querySelector('[data-ct-cart-preview-modal]');

  if (previewModal) {
    new CTCartPreviewModal(previewModal);
  }
});
